export interface Sponsor {
  name: string;
  image?: string;
  link?: string;
  class?: string;
}

export const MAIN_SPONSOR: Sponsor = {
  name: "To Be Determined",
  image: "",
  link: "",
};

export const CASE_SPONSORS: Sponsor[] = [
  {
    name: "sherpas",
    image: "/images/partners/sherpas_black_logo.jpg",
    link: "https://www.linkedin.com/company/sherpas-wealth/home/",
  },
  {
    name: "NTT Data",
    image: "/images/partners/ntt_data.svg",
    class: "max-w-[200px]",
    link: "https://www.nttdata.com/",
  },
  {
    name: "IDEAS UPV",
    image: "/images/partners/ideas_logo.png",
    link: "https://www.upv.es/entidades/ideas/",
  }
  /*Ocultos hasta confirmación de participación
  {
    name: "Maisa",
    image: "/images/partners/maisa_logo.png",
    link: "https://maisa.ai/",
  },
  {
    name: "Gurusup",
    image: "/images/partners/Gurusuplogo.png",
    link: "https://gurusup.com/",
  }*/
  /*{
    name: "NTT Data",
    image: "/images/partners/ntt_data.svg",
    class: "max-w-[200px]",
    link: "https://www.nttdata.com/",
  },

  {
    name: "LeapingAI",
    image: "/images/partners/leapingai.svg",
    link: "https://leapingai.com/",
  }
  ,
  {
    name: "IBM",
    image: "/images/partners/ibm.svg",
    link: "https://www.ibm.com/",
  }
  {
    name: "To Be Determined",
    image: "",
    link: "",
  }*/
];

export const CHALLENGE_SPONSORS: Sponsor[] = [
  /*{
    name: "Scientists360",
    image: "/images/partners/scientists360_2.svg",
    link: "https://scientists360.com/",
  },
  {
    name: "S2 Grupo",
    image: "/images/partners/s2grupo.svg",
    link: "https://www.s2grupo.com/",
  }*/
 {
    name: "ElevenLabs",
    image: "/images/partners/ElevenLabs_logo.png",
    link: "https://elevenlabs.io/",
  },
  {
    name: "Improven",
    image: "/images/partners/logo_improven_black.jpg",
    link: "https://improven.com/",
  }
];

export const TECH_SPONSORS: Sponsor[] = [
  {
    name: "Notion",
    image: "/images/partners/notionlogo.png",
    link: "https://www.notion.com/",
    class: "scale-110",
  },
  {
    name: "Lovable",
    image: "/images/partners/lovable_logo.svg",
    link: "https://lovable.dev/",
  },
  {
    name: "ElevenLabs",
    image: "/images/partners/ElevenLabs_logo.png",
    link: "https://elevenlabs.io/",
  }
  /*{
    name: "Lovable",
    image: "/images/partners/lovable_logo.svg",
    link: "https://lovable.dev/",
  }
  
  {
    name: "Lightspeed",
    image: "/images/partners/lightspeed.png",
    link: "https://lsvp.com/",
  },
  {
    name: "OpenAI",
    image: "/images/partners/OpenAI_Logo.svg",
    link: "https://openai.com/",
  },
  
  {
    name: "Langfuse",
    image: "/images/partners/langfuse_logo.svg",
    link: "https://langfuse.com/",
  },
  {
    name: "Make",
    image: "/images/partners/make.svg",
    link: "https://make.com/",
    class: "max-h-[30px]",
  }
    
   {
    name: "To Be Determined",
    image: "",
    link: "",
  }*/
];

export const FOOD_SPONSORS: Sponsor[] = [
  {
    name: "Red Bull",
    image: "/images/partners/redbulllogo.png",
    link: "https://www.redbull.com/",
  },
  {
    name: "MercadonaIT",
    image: "/images/partners/mercadonait_logo.png",
    link: "https://info.mercadona.es/es/mercadonait",
  },
  {
    name: "HP",
    image: "/images/partners/catedra-hp.png",
    link: "https://catedra-hp.webs.upv.es/",
  }
];

export const VENUE_SPONSORS: Sponsor = 
{
    name: "Terminal Hub",
    image: "/images/partners/terminalhub_logo.webp",
    link: "https://www.theterminalhub.com/",
};
/*{
  name: "ETSINF UPV",
  image: "/images/partners/etsinf.svg",
  link: "https://www.etsinf.upv.es/",
};*/
